function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "390",
  height: "220",
  viewBox: "0 0 390 220",
  focusable: "false"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a555d14f-bfbb-466c-abcf-1abc73fa7ec6",
  "data-name": "New Gradient Swatch 5",
  x1: "138.02",
  y1: "79.52",
  x2: "287.56",
  y2: "229.06",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0",
  stopColor: "#35abab"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".67",
  stopColor: "#676e96"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".89",
  stopColor: "#5c568f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#56488b"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bbb8d6b5-7542-43fd-9bd3-f543eaea4b02",
  x1: "9.41",
  y1: "145",
  x2: "125.63",
  y2: "145",
  xlinkHref: "#a555d14f-bfbb-466c-abcf-1abc73fa7ec6"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b524a8b9-e3bc-44e0-9e62-a47d74e72e4d",
  x1: "9.19",
  y1: "114.5",
  x2: "125.89",
  y2: "114.5",
  xlinkHref: "#a555d14f-bfbb-466c-abcf-1abc73fa7ec6"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bd7cb46e-3917-434e-a484-5f50b5d4a30b",
  x1: "1803.09",
  y1: "88.68",
  x2: "1889.03",
  y2: "174.63",
  gradientTransform: "matrix(-1, 0, 0, 1, 2156.06, 0)",
  xlinkHref: "#a555d14f-bfbb-466c-abcf-1abc73fa7ec6"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bcde8560-2d73-45be-98df-045ea52e26fa",
  x1: "1785.09",
  y1: "110.68",
  x2: "1871.03",
  y2: "196.63",
  gradientTransform: "matrix(-1, 0, 0, 1, 2156.06, 0)",
  xlinkHref: "#a555d14f-bfbb-466c-abcf-1abc73fa7ec6"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "fcc9c9f5-9aaf-4847-b3e8-7b2afae73df5",
  x1: "1767.09",
  y1: "132.68",
  x2: "1853.03",
  y2: "218.63",
  gradientTransform: "matrix(-1, 0, 0, 1, 2156.06, 0)",
  xlinkHref: "#a555d14f-bfbb-466c-abcf-1abc73fa7ec6"
}), /*#__PURE__*/React.createElement("clipPath", {
  id: "fe8e568e-2318-4490-a4ba-2dfed07f407a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M10.5 0h86v198h-86z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "faa04d00-51b6-4bae-9a6e-53bb1e654271"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M292.5 59h97v139h-97z"
}))), /*#__PURE__*/React.createElement("title", null, "2graphic_scene_trial"), /*#__PURE__*/React.createElement("g", {
  style: {
    isolation: "isolate"
  }
}, /*#__PURE__*/React.createElement("g", {
  id: "fa7bc9c4-5b1b-4101-8165-a153368117ce",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("rect", {
  y: "204",
  width: "390",
  height: "16",
  rx: "8",
  fill: "#7ca5cc",
  opacity: ".15"
}), /*#__PURE__*/React.createElement("path", {
  d: "M290.5 60h-192a2 2 0 00-2 2v148a2 2 0 002 2h192a2 2 0 002-2V62a2 2 0 00-2-2zm-186 23V69a1 1 0 011-1h18a1 1 0 011 1v14a1 1 0 01-1 1h-18a1 1 0 01-1-1zM125 203a1 1 0 01-1 1h-18a1 1 0 01-1-1v-14a1 1 0 011-1h18a1 1 0 011 1zm11.5-120V69a1 1 0 011-1h18a1 1 0 011 1v14a1 1 0 01-1 1h-18a1 1 0 01-1-1zM157 203a1 1 0 01-1 1h-18a1 1 0 01-1-1v-14a1 1 0 011-1h18a1 1 0 011 1zm11.5-120V69a1 1 0 011-1h18a1 1 0 011 1v14a1 1 0 01-1 1h-18a1 1 0 01-1-1zM189 203a1 1 0 01-1 1h-18a1 1 0 01-1-1v-14a1 1 0 011-1h18a1 1 0 011 1zm11.5-120V69a1 1 0 011-1h18a1 1 0 011 1v14a1 1 0 01-1 1h-18a1 1 0 01-1-1zM221 203a1 1 0 01-1 1h-18a1 1 0 01-1-1v-14a1 1 0 011-1h18a1 1 0 011 1zm11.5-120V69a1 1 0 011-1h18a1 1 0 011 1v14a1 1 0 01-1 1h-18a1 1 0 01-1-1zM253 203a1 1 0 01-1 1h-18a1 1 0 01-1-1v-14a1 1 0 011-1h18a1 1 0 011 1zm11.5-120V69a1 1 0 011-1h18a1 1 0 011 1v14a1 1 0 01-1 1h-18a1 1 0 01-1-1zM285 203a1 1 0 01-1 1h-18a1 1 0 01-1-1v-14a1 1 0 011-1h18a1 1 0 011 1z",
  fill: "url(#a555d14f-bfbb-466c-abcf-1abc73fa7ec6)"
}), /*#__PURE__*/React.createElement("rect", {
  x: "104.5",
  y: "92",
  width: "180",
  height: "88",
  rx: "1",
  style: {
    mixBlendMode: "multiply"
  },
  fill: "#193138",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M104.5 155.13V179a1 1 0 001 1h178a1 1 0 001-1v-24.9a44.94 44.94 0 01-13.58 8.23c-35.71 13.54-67.07-30.51-113.48-29.35-12.25.31-30.31 3.88-52.15 20.51a2 2 0 00-.79 1.64z",
  fill: "#7ca5cc",
  opacity: ".2"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "256.25",
  cy: "120.54",
  r: "20.54",
  fill: "#7ca5cc",
  opacity: ".2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M176.33 135a76.87 76.87 0 00-18.89-2c-12.25.31-30.31 3.88-52.15 20.51a2 2 0 00-.79 1.6V179a1 1 0 001 1h115.91a67.62 67.62 0 01-45.08-45z",
  fill: "#7ca5cc",
  opacity: ".15"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#fe8e568e-2318-4490-a4ba-2dfed07f407a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.5 121a48 48 0 0136.24-46.53 1 1 0 00.76-1V46a1 1 0 00-1-1 1 1 0 01-1-1V34a1 1 0 011-1h24a1 1 0 011 1v10a1 1 0 01-1 1 1 1 0 00-1 1v27.5a1 1 0 00.76 1A48 48 0 01110.5 121zM110.3 125.4a48 48 0 01-95.6 0 1 1 0 01.8-.4h94a1 1 0 01.8.4z",
  fill: "#7ca5cc",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.68 125h87.64a44 44 0 01-43.82 40h-1.73a44.3 44.3 0 01-42.09-40z",
  opacity: ".5",
  fill: "url(#bbb8d6b5-7542-43fd-9bd3-f543eaea4b02)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M106.5 121h-88a44.31 44.31 0 011.69-12A168.75 168.75 0 0140 108c12.2.11 18 1.49 29 2a169.57 169.57 0 0027.5-1h8.34a43.8 43.8 0 011.66 12z",
  opacity: ".5",
  fill: "url(#b524a8b9-e3bc-44e0-9e62-a47d74e72e4d)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62.5 173s-5 4.79-5 10.69c0 3.36.77 6.36 2.53 8.31h1.48a14.33 14.33 0 01-1.51-6.12 15.19 15.19 0 012.5-7.88 15.19 15.19 0 012.5 7.88 14.33 14.33 0 01-1.51 6.12H65c1.76-1.95 2.53-4.95 2.53-8.31-.03-5.9-5.03-10.69-5.03-10.69z",
  fill: "#7ca5cc",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M114.49 121.87a1 1 0 00-1-.87H11.5a1 1 0 00-1 .87.57.57 0 000 .13v75a1 1 0 001 1h102a1 1 0 001-1v-75a.57.57 0 00-.01-.13zm-4 71.13a1 1 0 01-1 1H66v-1a1 1 0 00-1-1h-5a1 1 0 00-1 1v1H15.5a1 1 0 01-1-1v-67a1.05 1.05 0 01.2-.6 1 1 0 01.8-.4h94a1 1 0 01.8.4 1.05 1.05 0 01.2.6z",
  fill: "#7ca5cc",
  opacity: ".5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M65 185.88a14.33 14.33 0 01-1.51 6.12h-2a14.33 14.33 0 01-1.49-6.12 15.19 15.19 0 012.5-7.88 15.19 15.19 0 012.5 7.88z",
  fill: "#7ca5cc",
  opacity: ".25"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "58",
  cy: "23",
  r: "6",
  fill: "#7ca5cc",
  opacity: ".15"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "73",
  cy: "9",
  r: "8",
  fill: "#7ca5cc",
  opacity: ".15"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#faa04d00-51b6-4bae-9a6e-53bb1e654271)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M308 96h-24v82a12 12 0 0012.22 12A12.26 12.26 0 00308 177.6zM282 86v4a2 2 0 002 2h24a2 2 0 002-2v-4a2 2 0 00-2-2h-24a2 2 0 00-2 2z",
  fill: "#7ca5cc",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M296.5 186a8 8 0 008-8v-69h-16v69a8 8 0 008 8z",
  opacity: ".5",
  fill: "url(#bd7cb46e-3917-434e-a484-5f50b5d4a30b)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M338 96h-24v82a12 12 0 0012.22 12A12.26 12.26 0 00338 177.6zM312 86v4a2 2 0 002 2h24a2 2 0 002-2v-4a2 2 0 00-2-2h-24a2 2 0 00-2 2z",
  fill: "#7ca5cc",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M326.5 186a8 8 0 008-8v-49h-16v49a8 8 0 008 8z",
  opacity: ".5",
  fill: "url(#bcde8560-2d73-45be-98df-045ea52e26fa)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M368 96h-24v82a12 12 0 0012.22 12A12.26 12.26 0 00368 177.6zM342 86v4a2 2 0 002 2h24a2 2 0 002-2v-4a2 2 0 00-2-2h-24a2 2 0 00-2 2z",
  fill: "#7ca5cc",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M356.5 186a8 8 0 008-8v-29h-16v29a8 8 0 008 8z",
  opacity: ".5",
  fill: "url(#fcc9c9f5-9aaf-4847-b3e8-7b2afae73df5)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M274 93v104a1 1 0 001 1h102a1 1 0 001-1V93a1 1 0 00-1-1H275a1 1 0 00-1 1zm4 4a1 1 0 011-1h94a1 1 0 011 1v96a1 1 0 01-1 1h-94a1 1 0 01-1-1z",
  fill: "#7ca5cc",
  opacity: ".5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M362 105.5a5.5 5.5 0 01-11 0c0-3 2.46-3.5 5.5-3.5s5.5.46 5.5 3.5z",
  fill: "#7ca5cc",
  opacity: ".15"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "326.5",
  cy: "118.5",
  r: "5.5",
  fill: "#7ca5cc",
  opacity: ".15"
})), /*#__PURE__*/React.createElement("g", {
  opacity: ".15",
  fill: "#7ca5cc"
}, /*#__PURE__*/React.createElement("rect", {
  x: "351",
  y: "56",
  width: "22",
  height: "18",
  rx: "4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M356 79.43V74h8l-6.86 5.83c-.42.36-1.14.11-1.14-.4z"
}))))));